var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecuritySafeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9406 7.41288C13.9406 10.6729 11.5739 13.7262 8.34056 14.6195C8.12056 14.6795 7.88054 14.6795 7.66054 14.6195C4.42721 13.7262 2.06055 10.6729 2.06055 7.41288V4.4862C2.06055 3.93953 2.47389 3.31954 2.98722 3.11287L6.70054 1.59289C7.53387 1.25289 8.47388 1.25289 9.30721 1.59289L13.0205 3.11287C13.5272 3.31954 13.9472 3.93953 13.9472 4.4862L13.9406 7.41288Z",
    stroke: "#FF8400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 8.33366C8.73573 8.33366 9.33268 7.73671 9.33268 7.00033C9.33268 6.26395 8.73573 5.66699 7.99935 5.66699C7.26297 5.66699 6.66602 6.26395 6.66602 7.00033C6.66602 7.73671 7.26297 8.33366 7.99935 8.33366Z",
    stroke: "#FF8400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.33398V10.334",
    stroke: "#FF8400",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafeActive);
export default __webpack_public_path__ + "static/media/security-safe_active.68b9f0494e63481ad1739e5fac3ec290.svg";
export { ForwardRef as ReactComponent };